import React from 'react';
const AboutV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-about" id="about" data-testid="iv2-about">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <p className="iv2-about-body" data-testid="iv2-about-body">{copy.body}</p>
        <p className="iv2-about-signature">
          <span className="iv2-about-name">{copy.name}</span>
          <span className="iv2-about-role">{copy.role}</span>
        </p>
      </div>
    </section>
  );
};
export default AboutV2;
